import { render, staticRenderFns } from "./EmoticonOutline.vue?vue&type=template&id=b9db1c76&functional=true&"
import script from "./EmoticonOutline.vue?vue&type=script&lang=js&"
export * from "./EmoticonOutline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports